import { CrosswordInput } from '../types';

export type GameMode = 'classic' | 'large';

export const LARGE_STORAGE_OFFSET = 100000;
export const CLASSIC_START = new Date('2022-09-19T00:00:00');
export const LARGE_START = new Date('2026-09-08T00:00:00');

export function modeFromPath(pathname: string): GameMode {
  return pathname.startsWith('/7x7') ? 'large' : 'classic';
}

export function modeBasePath(mode: GameMode) {
  return mode === 'large' ? '/7x7' : '';
}

export function storageIndex(mode: GameMode, puzzleIndex: number) {
  return mode === 'large' ? LARGE_STORAGE_OFFSET + puzzleIndex : puzzleIndex;
}

export function storageIndexBelongsToMode(mode: GameMode, index: number) {
  return mode === 'large' ? index >= LARGE_STORAGE_OFFSET : index < LARGE_STORAGE_OFFSET;
}

export function modeLabel(mode: GameMode) {
  return mode === 'large' ? '7×7' : '5×5';
}

export function maxGuessesForWord(_mode: GameMode, wordLength: number) {
  return wordLength;
}

export function puzzleTitle(mode: GameMode, puzzleIndex: number) {
  return mode === 'large'
    ? `Crosswordle 7×7 #${puzzleIndex + 1}`
    : `Crosswordle ${puzzleIndex + 1}`;
}

export function startDateForMode(mode: GameMode) {
  return mode === 'large' ? LARGE_START : CLASSIC_START;
}

export type GameContextValue = {
  mode: GameMode;
  puzzleIndex: number;
  storageIndex: number;
  puzzle: CrosswordInput;
  todayIndex: number;
};
